import { useState } from 'react';
import { parseDate } from 'utils/date';
import dayjs, { Dayjs } from 'utils/dayjs';
import { usePublicHolidaysQuery } from 'utils/graphql/queries/__generated__/publicHolidays';

interface Params {
  value: Dayjs;
  highlightPublicHolidays: boolean;
}

export const usePublicHolidays = ({ value, highlightPublicHolidays }: Params) => {
  const [holidayTargetDate, setHolidayTargetDate] = useState<Dayjs>(value || dayjs());
  const startDate = parseDate(holidayTargetDate).startOf('year');
  const endDate = parseDate(holidayTargetDate).endOf('year');
  const { data: publicHolidaysData } = usePublicHolidaysQuery({
    variables: {
      endDate: endDate.toISOString(),
      startDate: startDate.toISOString(),
    },
    skip: !highlightPublicHolidays,
  });

  const handlePanelChange = (value: Dayjs) => {
    setHolidayTargetDate(value);
  };

  const isPublicHoliday = (date: Dayjs) => {
    if (!highlightPublicHolidays) {
      return false;
    }

    return publicHolidaysData?.publicHolidays?.includes(date.format('YYYY-MM-DD'));
  };

  return {
    publicHolidaysData,
    handlePanelChange,
    isPublicHoliday,
  };
};
